import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../SQL';
import { FormateoFechaPara_yyyyMMdd, TratamientoDeParametroParaURI } from '../Varios';
import { function_ABM_EEX_Personas_Leer } from '../ABM/EEX/ABM_EEX_Personas';
import { function_ABM_CON_CuentasFinancieras_Leer } from '../ABM/CONT/ABM_CON_CuentasFinancieras';
import { function_ABM_CON_Monedas_Leer } from '../ABM/CONT/ABM_CON_Monedas';
import { function_TODOS_Parametros_Listar } from '../TODOS_Parametros';

export const function_CON_OperacionesParaImportar_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Listar"

    try {
        const resulData = await llamadaAPI_GET("CON_OperacionesParaImportar/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_ListarSoloSinGenerar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_ListarSoloSinGenerar"

    try {
        const resulData = await llamadaAPI_GET("CON_OperacionesParaImportar/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            TratamientoDeParametroParaURI("AND ISNULL(CON_OperacionesParaImportar.IdOperacion1, 0) = 0"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_Leer = async (IdOperacion) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Leer"

    try {
        const resulData = await llamadaAPI_GET("CON_OperacionesParaImportar/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdOperacion);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_Generar_JSON = async (Fecha, Descripcion, Importe, IdTipoOperacion, Cantidad,
    CodigoArticulo, CodigoPresentacion, CodigoTamano, CodigoUnidadMedida, CodigoUbicacionIngreso, CodigoSubCC,
    CodigoCuentaFinanciera, Cuotas, IdOperacion1, IdOperacion2, IdCliente, IdProveedor, IdUsuarioAuditoria,
    CodigoMoneda, Cotizacion, Factura, IdTipoDocumento, ImportePercepcionIIBB, ImportePercepcionIVA,
    ImportePercepcionSUSS, ImportePercepcionGanancias, ImportePercepcionImpuestosInternos, ComprobantePercepcionIIBB,
    ComprobantePercepcionIVA, ComprobantePercepcionSUSS, ComprobantePercepcionGanancias, ComprobantePercepcionImpuestosInternos,
    ImporteRetencionIIBB, ImporteRetencionIVA, ImporteRetencionSUSS, ImporteRetencionGanancias, ImporteRetencionImpuestosInternos,
    ComprobanteRetencionIIBB, ComprobanteRetencionIVA, ComprobanteRetencionSUSS, ComprobanteRetencionGanancias,
    ComprobanteRetencionImpuestosInternos, ImporteExento, ImporteIVA10, ImporteIVA21, ImporteIVA27, 
    CodigoCuentaContableDocCompraVenta, CodigoCuentaContablePagoRecibo, NCPorcentaje, NCIdProveedor, Socio1Porcentaje, Socio1IdPersona,
    Socio2Porcentaje, Socio2IdPersona, Socio3Porcentaje, Socio3IdPersona, Socio4Porcentaje, Socio4IdPersona,
    NDPorcentaje, NDIdProveedor, CodigoPlanta) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Generar_JSON";

    try {

        const JSON = {
            Fecha: Fecha,
            Descripcion: Descripcion,
            Importe: Importe,
            IdTipoOperacion: IdTipoOperacion,
            Cantidad: Cantidad,
            CodigoArticulo: CodigoArticulo,
            CodigoPresentacion: CodigoPresentacion,
            CodigoTamano: CodigoTamano,
            CodigoUnidadMedida: CodigoUnidadMedida,
            CodigoUbicacionIngreso: CodigoUbicacionIngreso,
            CodigoSubCC: CodigoSubCC,
            CodigoCuentaFinanciera: CodigoCuentaFinanciera,
            Cuotas: Cuotas,
            IdOperacion1: IdOperacion1,
            IdOperacion2: IdOperacion2,
            IdEstado: 10,
            IdCliente: IdCliente,
            IdProveedor: IdProveedor,
            IdUsuarioAuditoria: IdUsuarioAuditoria,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoMoneda: CodigoMoneda,
            Cotizacion: Cotizacion,
            Factura: Factura,
            IdTipoDocumento: IdTipoDocumento,
            ImportePercepcionIIBB: ImportePercepcionIIBB,
            ImportePercepcionIVA: ImportePercepcionIVA,
            ImportePercepcionSUSS: ImportePercepcionSUSS,
            ImportePercepcionGanancias: ImportePercepcionGanancias,
            ImportePercepcionImpuestosInternos: ImportePercepcionImpuestosInternos,
            ComprobantePercepcionIIBB: ComprobantePercepcionIIBB,
            ComprobantePercepcionIVA: ComprobantePercepcionIVA,
            ComprobantePercepcionSUSS: ComprobantePercepcionSUSS,
            ComprobantePercepcionGanancias: ComprobantePercepcionGanancias,
            ComprobantePercepcionImpuestosInternos: ComprobantePercepcionImpuestosInternos,
            ImporteRetencionIIBB: ImporteRetencionIIBB,
            ImporteRetencionIVA: ImporteRetencionIVA,
            ImporteRetencionSUSS: ImporteRetencionSUSS,
            ImporteRetencionGanancias: ImporteRetencionGanancias,
            ImporteRetencionImpuestosInternos: ImporteRetencionImpuestosInternos,
            ComprobanteRetencionIIBB: ComprobanteRetencionIIBB,
            ComprobanteRetencionIVA: ComprobanteRetencionIVA,
            ComprobanteRetencionSUSS: ComprobanteRetencionSUSS,
            ComprobanteRetencionGanancias: ComprobanteRetencionGanancias,
            ComprobanteRetencionImpuestosInternos: ComprobanteRetencionImpuestosInternos,
            ImporteExento: ImporteExento,
            ImporteIVA10: ImporteIVA10,
            ImporteIVA21: ImporteIVA21,
            ImporteIVA27: ImporteIVA27,
            Terminal: localStorage.getItem("Terminal"), 
            CodigoCuentaContableDocCompraVenta: CodigoCuentaContableDocCompraVenta,
            CodigoCuentaContablePagoRecibo: CodigoCuentaContablePagoRecibo,
            NCPorcentaje: NCPorcentaje,
            NCIdProveedor: NCIdProveedor,
            Socio1Porcentaje: Socio1Porcentaje,
            Socio1IdPersona: Socio1IdPersona,
            Socio2Porcentaje: Socio2Porcentaje,
            Socio2IdPersona: Socio2IdPersona,
            Socio3Porcentaje: Socio3Porcentaje,
            Socio3IdPersona: Socio3IdPersona,
            Socio4Porcentaje: Socio4Porcentaje,
            Socio4IdPersona: Socio4IdPersona,
            NDPorcentaje: NDPorcentaje,
            NDIdProveedor: NDIdProveedor,
            CodigoPlanta: CodigoPlanta
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_ParaGasto_Generar_JSON = async (Importe, Descripcion, CodigoArticulo, 
    IdPersonaResponsable, IdPersonaAutorizante, CodigoCuentaFinanciera) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_ParaSobranteCaja_Generar_JSON";

    try {
        // Validaciones
        if (!Importe || isNaN(Importe) || Importe <= 0) {
            throw new Error("El Importe debe ser mayor a cero.");
        }
        if (!Descripcion || Descripcion.trim() === "") {
            throw new Error("La Descripción no puede estar vacía.");
        }
        if (!CodigoArticulo || CodigoArticulo.trim() === "") {
            throw new Error("El Código de Artículo es requerido.");
        }
        if (!IdPersonaResponsable || IdPersonaResponsable <= 0) {
            throw new Error("Debe proporcionar a la Persona Responsable.");
        }
        if (!IdPersonaAutorizante || IdPersonaAutorizante <= 0) {
            throw new Error("Debe proporcionar a la Persona Autorizante.");
        }
        if (!CodigoCuentaFinanciera || CodigoCuentaFinanciera.trim() === "") {
            throw new Error("El código de la Cuenta Financiera es requerido.");
        }

        const personaResult = await function_ABM_EEX_Personas_Leer(IdPersonaResponsable)
        const personaAutorizanteResult = await function_ABM_EEX_Personas_Leer(IdPersonaAutorizante)
        const cuentaFinancieraResult = await function_ABM_CON_CuentasFinancieras_Leer(CodigoCuentaFinanciera)
        const monedaResult = await function_ABM_CON_Monedas_Leer(cuentaFinancieraResult.data[0].CodigoMoneda)
        
        const JSON = await function_CON_OperacionesParaImportar_Generar_JSON(FormateoFechaPara_yyyyMMdd(new Date()),
            Descripcion + " - Responsable: " + personaAutorizanteResult.data.Apellido + ", " + personaAutorizanteResult.data.Nombre,
            Importe, 1, 1, CodigoArticulo, "DEF", "DEF", "UN", "DEF", "",
            cuentaFinancieraResult.data[0].CodigoCuentaFinanciera, 1, 0, 0, personaResult.data.IdCliente, 0,
            localStorage.getItem("IdPersona"), monedaResult.data[0].CodigoMoneda,
            monedaResult.data[0].Cotizacion, "", 41, 0, 0, 0, 0, 0, "", "", "", "", "", 0, 0, 0, 0, 0, "", "", "", "", "",
            0, 0, 0, 0, "", "", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
            localStorage.getItem("CodigoPlanta"))

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_ParaSobranteCaja_Generar_JSON = async (EsAperturaNoEsCierre, Importe,
    CodigoCuentaFinanciera, IdPersonaResponsable) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_ParaSobranteCaja_Generar_JSON";

    try {
        // Validaciones
        if (!Importe || isNaN(Importe) || Importe <= 0) {
            throw new Error("El Importe debe ser mayor a cero.");
        }
        if (!IdPersonaResponsable || IdPersonaResponsable <= 0) {
            throw new Error("Debe proporcionar a la Persona Responsable.");
        }
        if (!CodigoCuentaFinanciera || CodigoCuentaFinanciera.trim() === "") {
            throw new Error("El código de la Cuenta Financiera es requerido.");
        }

        const personaResult = await function_ABM_EEX_Personas_Leer(IdPersonaResponsable)
        const cuentaFinancieraResult = await function_ABM_CON_CuentasFinancieras_Leer(CodigoCuentaFinanciera)
        const monedaResult = await function_ABM_CON_Monedas_Leer(cuentaFinancieraResult.data[0].CodigoMoneda)
        const parametrosResult = await function_TODOS_Parametros_Listar()
        let CodigoArticulo = ""
        parametrosResult.data.forEach(parametro => {
            if (parametro.Parametro === "VentasCodigoArticuloSobranteDeCaja") {
                CodigoArticulo = parametro.Valor
            }           
        });
        
        let Descripcion = "CIERRE"
        if (EsAperturaNoEsCierre) {
            Descripcion = "APERTURA"
        }

        const JSON = await function_CON_OperacionesParaImportar_Generar_JSON(FormateoFechaPara_yyyyMMdd(new Date()),
            "SOBRANTE DE CAJA " + Descripcion + " - Responsable: " + personaResult.data.IdPersona + " - " + personaResult.data.Apellido + ", " + personaResult.data.Nombre,
            Importe, 4, 1, CodigoArticulo, "DEF", "DEF", "UN", "DEF", "",
            cuentaFinancieraResult.data[0].CodigoCuentaFinanciera, 1, 0, 0, personaResult.data.IdCliente, 0,
            localStorage.getItem("IdPersona"), monedaResult.data[0].CodigoMoneda,
            monedaResult.data[0].Cotizacion, "", 41, 0, 0, 0, 0, 0, "", "", "", "", "", 0, 0, 0, 0, 0, "", "", "", "", "",
            0, 0, 0, 0, "", "", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            localStorage.getItem("CodigoPlanta"))

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_ParaFaltanteCaja_Generar_JSON = async (EsAperturaNoEsCierre, Importe,
    CodigoCuentaFinanciera, IdPersonaResponsable) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_ParaFaltanteCaja_Generar_JSON";

    try {
        // Validaciones
        if (!Importe || isNaN(Importe) || Importe <= 0) {
            throw new Error("El Importe debe ser mayor a cero.");
        }
        if (!IdPersonaResponsable || IdPersonaResponsable <= 0) {
            throw new Error("Debe proporcionar a la Persona Responsable.");
        }
        if (!CodigoCuentaFinanciera || CodigoCuentaFinanciera.trim() === "") {
            throw new Error("El código de la Cuenta Financiera es requerido.");
        }

        const personaResult = await function_ABM_EEX_Personas_Leer(IdPersonaResponsable)
        const cuentaFinancieraResult = await function_ABM_CON_CuentasFinancieras_Leer(CodigoCuentaFinanciera)
        const monedaResult = await function_ABM_CON_Monedas_Leer(cuentaFinancieraResult.data[0].CodigoMoneda)
        const parametrosResult = await function_TODOS_Parametros_Listar()
        let CodigoArticulo = ""
        parametrosResult.data.forEach(parametro => {
            if (parametro.Parametro === "VentasCodigoArticuloFaltanteDeCaja") {
                CodigoArticulo = parametro.Valor
            }           
        });
        
        let Descripcion = "CIERRE"
        if (EsAperturaNoEsCierre) {
            Descripcion = "APERTURA"
        }

        const JSON = await function_CON_OperacionesParaImportar_Generar_JSON(FormateoFechaPara_yyyyMMdd(new Date()),
            "FALTANTE DE CAJA " + Descripcion + " - Responsable: " + personaResult.data.IdPersona + " - " + personaResult.data.Apellido + ", " + personaResult.data.Nombre,
            Importe, 1, 1, CodigoArticulo, "DEF", "DEF", "UN", "DEF", "",
            cuentaFinancieraResult.data[0].CodigoCuentaFinanciera, 1, 0, 0, 0, personaResult.data.IdProveedor,
            localStorage.getItem("IdPersona"), monedaResult.data[0].CodigoMoneda,
            monedaResult.data[0].Cotizacion, "", 41, 0, 0, 0, 0, 0, "", "", "", "", "", 0, 0, 0, 0, 0, "", "", "", "", "",
            0, 0, 0, 0, "", "", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            localStorage.getItem("CodigoPlanta"))

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_Insertar = async (Operacion) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Insertar";

    try {
        const operacionResult = await llamadaAPI_POST("CON_OperacionesParaImportar/InsertarCompleto/",
            Operacion);
        return operacionResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_Modificar = async (Operacion) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Modificar";

    try {
        const operacionResult = await llamadaAPI_PUT("CON_OperacionesParaImportar/ModificarCompleto/",
            Operacion);
        return operacionResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_Importar = async (ColumnaFecha, ColumnaCantidad, ColumnaCuotas, 
    ColumnaDescripcion, ColumnaCodigoCuentaFinanciera,
    ColumnaCodigoArticulo, ColumnaCodigoPresentacion, ColumnaCodigoTamano,
    ColumnaCodigoUnidadMedida, ColumnaImporteNeto, ColumnaImporteIVA105, ColumnaImporteIVA21, Coleccion) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Importar"

    try {
        const resulData = await llamadaAPI_POST("CON_OperacionesParaImportar/Importar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(ColumnaFecha) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCantidad) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCuotas) + "/" +
            await TratamientoDeParametroParaURI(ColumnaDescripcion) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoCuentaFinanciera) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoArticulo) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoPresentacion) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoTamano) + "/" +
            await TratamientoDeParametroParaURI(ColumnaCodigoUnidadMedida) + "/" +
            await TratamientoDeParametroParaURI(ColumnaImporteNeto) + "/" +
            await TratamientoDeParametroParaURI(ColumnaImporteIVA105) + "/" +
            await TratamientoDeParametroParaURI(ColumnaImporteIVA21),
            Coleccion);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_OperacionesParaImportar_Generar = async (IdItem, Terminal, IdUsuarioCreador) => {
    const NombreFuncion = "function_CON_OperacionesParaImportar_Leer"

    try {
        const resulData = await llamadaAPI_GET("CON_OperacionesParaImportar/Generar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdItem + "/" + 
            Terminal + "/" + 
            IdUsuarioCreador);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};
